import { useRef } from 'react';
import moment from 'moment';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import useFilterSaveHook from '@/pages/intelligence/hooks/useFilterSaveHook';
import { useSelector, history } from 'umi';
import {
  saveFilterValueStorage,
  saveFilterName,
  getFilterName,
  getFilterValueStorage,
} from '@/pages/intelligence/components/Filter/util';
import { getDbiUrlParams, onFilterConfirm } from '@intelligence/components/Filter/util';
// import { FILTERSAVE_TYPE } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/AllMetrics/utils';
// import { updateFilterSaveList } from '@/pages/intelligence/services/common';
// import type { IAllMetricsSaveParams } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/AllMetrics/types';

interface FilterSavePropsType {
  defaultValue?: any;
  formValue?: any;
  setFormValue?: any;
  timeFilterValues?: any;
  inputList?: any;
  formatFormValue?: Function;
  onConfirm?: Function;
  onChangeExtra?: Function;
  /**
   * 提供给外部调用者在setFormValue前根据自己业务调整formValue
   * @param 本次修改的筛选器的key
   * @param formValue
   * @return 调整后的formValue
   */
  adjustFormValue?: (key: string, formValue: any) => any;
  onChangeExtraLast?: Function;
  filterSaveType?: string;
}
function useFilterUseHook(props: FilterSavePropsType) {
  const {
    defaultValue = {},
    formValue = {},
    setFormValue = () => console.log,
    timeFilterValues,
    formatFormValue,
    onConfirm,
    onChangeExtra,
    adjustFormValue,
    onChangeExtraLast,
    inputList,
    filterSaveType = '',
    // updateFilterSaveListHandle,
  } = props || {};
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  // 在筛选器这里拿到缓存的值，并渲染
  const filterName = getFilterName(userInfo);
  const filterData = getFilterValueStorage(userInfo);

  const { getFilterItemByFilterName, removeFilterSave } = useFilterSaveHook({
    filterSaveType,
  });

  // 使用 useRef 记录上次的 formValue，用于判断筛选器值是否真正变化
  const prevFormValueRef = useRef(formValue);

  // 和公共筛选器配置组件一样的功能，旧的没用配置组件的还在用，新的已弃用
  // 配置组件：src\pages\intelligence\pages\TopCharts\components\CommonFilter\index.tsx
  const updateFormValue = (params?: any) => {
    try {
      const formUpdateValue = formValue;
      let newFormValue = {
        ...formUpdateValue,
      };
      const urlParams: any = getDbiUrlParams(history);
      if (Object.keys(urlParams)?.length) {
        // 优先使用url的值
        saveFilterName(userInfo, ''); // 清除缓存
      } else if (filterName && filterData) {
        // 否则使用保存的值，最后才是继承的值
        const filterValues = filterData?.value;
        const formatFilterValues = formatFormValue ? formatFormValue(filterValues) : filterValues;
        const filterSaveValue = {
          ...defaultValue,
          ...formatFilterValues,
          [filterKeyMap.MY_FILTER]: {
            value: filterName,
          },
        };
        newFormValue = { ...newFormValue, ...filterSaveValue };
      }
      // 接收外面传来的值并更新
      if (params && Object.prototype.toString.call(params) === '[object Object]') {
        newFormValue = { ...newFormValue, ...params };
      }
      // 更新接口返回的时间 -- feat params里的时间为空，下面依然可以更新时间值
      if (Array.isArray(timeFilterValues?.value) && timeFilterValues?.value.length === 2) {
        newFormValue = {
          ...newFormValue,
          [filterKeyMap.RANGE_TIME]: {
            type: feachTimeTypeToFilterTimeType(timeFilterValues?.type), // TODO
            value: [moment(timeFilterValues?.value[0]), moment(timeFilterValues?.value[1])],
          },
        };
      }
      setFormValue(newFormValue);
    } catch (err) {
      console.error(err);
    }
  };

  function filterKeys(obj: any, keys: string[]) {
    try {
      const result: any = {};
      Object.keys(obj).forEach((key) => {
        if (keys.includes(key)) {
          result[key] = obj[key];
        }
      });
      return result;
    } catch (err) {
      return obj;
    }
  }

  // 判断筛选器值是否真正变化（只对比核心字段，忽略内部状态字段）
  const isFilterValueReallyChanged = (key: string, prevValue: any, currentValue: any): boolean => {
    // 如果是 genretor 筛选器，只对比核心字段
    if (key === filterKeyMap.GENRETOR) {
      const prevCore = {
        source: prevValue?.source,
        mainGenres: prevValue?.mainGenres,
        subGenres: prevValue?.subGenres,
        level3Genres: prevValue?.level3Genres,
        level4Genres: prevValue?.level4Genres,
      };
      const currentCore = {
        source: currentValue?.source,
        mainGenres: currentValue?.mainGenres,
        subGenres: currentValue?.subGenres,
        level3Genres: currentValue?.level3Genres,
        level4Genres: currentValue?.level4Genres,
      };
      return JSON.stringify(prevCore) !== JSON.stringify(currentCore);
    }

    // 其他筛选器使用默认对比
    return JSON.stringify(prevValue) !== JSON.stringify(currentValue);
  };

  const onFilterChange = (key: string, value: any, newValue: any, isNoButtonMyFilter = false) => {
    // filterChange 时的额外操作
    onChangeExtra?.(key, value, newValue);
    /** 将筛选器操作更新到url
    const newValuenewValue = onFilterConfirm(newValue)?.apiValue;
    let urlObj = {};
    for (let k in newValuenewValue) {
      if (newValuenewValue[k]?.urlValueFormat) {
        urlObj = Object.assign(urlObj, newValuenewValue[k]?.urlValueFormat);
      }
    }
    setGameInfoToUrl(urlObj);
    */
    // console.log('onFilterChangeonFilterChange-isNoButtonMyFilter', isNoButtonMyFilter);
    // console.log('onFilterChangeonFilterChange-key', key);
    // console.log('onFilterChangeonFilterChange-value', value);
    // console.log('onFilterChangeonFilterChange-newValue', newValue);
    if (key !== filterKeyMap.MY_FILTER) {
      // 判断当前筛选器的值是否真正发生变化
      const prevValue = prevFormValueRef.current?.[key];
      const isValueChanged = isFilterValueReallyChanged(key, prevValue, value);

      let newFormValue = {
        ...newValue,
        // 只有值真正变化时才清空 My Filter，否则保持原值
        [filterKeyMap.MY_FILTER]: {
          value: isValueChanged ? '' : newValue[filterKeyMap.MY_FILTER]?.value || '',
        },
      };
      // 提供外部调用者最后一次调整formValue的途径
      if (typeof adjustFormValue === 'function') {
        newFormValue = { ...newFormValue, ...adjustFormValue(key, newFormValue) };
      }
      setFormValue(newFormValue);
      // 更新 ref 中的值
      prevFormValueRef.current = newFormValue;
      onChangeExtraLast?.(key, value, newValue);
    } else {
      // 如果指标筛选器选器值变化，只有 mscience 数据时国家地区指定 us, 其他时选择全球

      // 如果是操作的下拉保存，则将选项的值渲染到对应筛选器上
      const filterSaveFormValues = getFilterItemByFilterName(value?.value);
      // console.log('onFilterChangeonFilterChange-formatFormValue', formatFormValue);
      // console.log('onFilterChangeonFilterChange-filterSaveFormValues', filterSaveFormValues);
      const formatFilterValues = formatFormValue
        ? formatFormValue(filterSaveFormValues?.value)
        : filterSaveFormValues?.value;
      const formValueObj = {
        ...defaultValue,
        // 保存的筛选器数据
        ...formatFilterValues,
        // 当前筛选的保存值
        [filterKeyMap.MY_FILTER]: {
          value: value.value,
        },
      };
      setFormValue(formValueObj);
      // 更新 ref 中的值
      prevFormValueRef.current = formValueObj;

      if (isNoButtonMyFilter) {
        const filterListKeys = inputList?.map((t: any) => t?.key ?? t?.type);
        const result = filterKeys(formValueObj, filterListKeys);
        // console.log('resultresultresult4444', result);
        // 把没有展示的筛选器过滤掉；
        const { error, value, apiValue } = onFilterConfirm(result);

        // console.log('ifNoButtonMyFiltervaluevaluevalue', value);
        // console.log('ifNoButtonMyFilterapiValueCurapiapiValue', apiValue);
        if (!error) {
          // console.log('onConfirmonConfirmonConfirm12214324234', value);
          onConfirm?.(value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */);
        }
      }
    }
  };

  const onSaveFilterMsg = (value: any, _apiValue: any) => {
    // 点击确认后，将筛选器保存方案及保存数据存到缓存中
    const filterNameValue = value[filterKeyMap.MY_FILTER]?.value;
    // 清除缓存
    saveFilterName(userInfo, filterNameValue);
    const filterItems = getFilterItemByFilterName(filterNameValue);
    saveFilterValueStorage(userInfo, filterNameValue ? filterItems : null);
  };

  const onRemoveFilterMsg = (name: string) => {
    removeFilterSave({ name });
    if (filterName === name) {
      // 如果删除的项是目前保存中的方案，则删除缓存
      saveFilterName(userInfo, ''); // 清除缓存
      saveFilterValueStorage(userInfo, null);
    }
  };

  return {
    filterName,
    filterData,
    filterSaveName: filterName,
    filterSaveData: filterData,
    updateFormValue,
    onFilterChange,
    onSaveFilterMsg,
    onRemoveFilterMsg,
  };
}

export default useFilterUseHook;
